import React from 'react'

import styled from '@emotion/styled'
import { mq, grayBg } from '../../../_style';

const Container = styled.section(props => `
${mq.pc} {
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    background-image: url(${props.bg});
    height: 356px;
    position: relative;
  }
  ${mq.sp} {
    background-color: ${grayBg};
    &::before {
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      background-image: url(${props.bgSp});
      content: "";
      display: block;
      padding-bottom: ${528/750*100}%;
    }
  }
`);

export default class AboutDetailMain extends React.Component {
  render() {
    return(
      <Container bg={this.props.bg} bgSp={this.props.bgSp}></Container>
    );
  }
}
